function fn_comp_hp_news() {
    var $fn = $(".comp_hp_news");

    if($fn.length) {
        var $slider = $fn.find("[data-news-slider]");

        if ($slider.length) {
            $slider.slick({
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                nextArrow: "<span class=\"icon--chevron-right slick-next\"></span>",
                prevArrow: "<span class=\"icon--chevron-left slick-prev\"></span>",
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });

            // $slider.on('click',"[aria-disabled=true]", function() {
            //     var $this = $(this);
            //     var $addBefore = ($this.hasClass("slick-prev"));
            //     console.log($addBefore);
            //
            //     setTimeout(function () {
            //         /*AJAX Sim*/
            //
            //         //slide nacteny AJAXem
            //         var $slide = "<div class=\"part_news ajaxed\"><img src=\"//placehold.it/232x232?text=AJAX\" /><div class=\"elm_text\"><h3>AJAXovy titulek</h3><p>AJAXovy perex AJAXem nacteneho clanku</p></div><a href=\"article.html\" class=\"part_ui_btn part_ui_btn_primary\">více</a></div>"
            //
            //         $slider.slick("slickAdd",$slide,$addBefore);
            //     },2000)
            // });
        }
    }
}